import { STATUS, logger } from './utils'

const responseHandler = ({ response = {}, actions = {} }) => {
    const { request = {}, data, status } = response
    logger({
        origin: 'API - RESPONSE',
        endpoint: request.responseURL,
        response: JSON.stringify(data),
        status: status || request.status,
    })
    return response
}

const errorHandler = ({
    error = {}, setAuthorization, actions = {}, refreshTokenUrl = '/auth/token',
}) => {
    // Transport failures (timeouts, refused connections, CORS) reject with no
    // `response` at all, so it has to default: destructuring it blindly threw a
    // TypeError that masked the real error.
    const { response = {}, request = {} } = error
    const { onSignout } = actions
    const { status } = response
    const { responseURL: endpoint } = request

    logger({ origin: `API - ERROR ${status}`, endpoint, status })

    if (status === STATUS.UNAUTHORIZED && onSignout) {
        onSignout()
    }

    return error
}

export default {
    responseHandler,
    errorHandler,
}
